import {
  GenericHeader,
  NavigationBarWrapper,
  Profile,
  LoginExpireModal,
  Login,
  RegisterPage,
  ResetPassword,
  ResetPasswordPage,
  userPreference,
  getApplicationFeatures,
  featureList,
  getAppContextRoute,
  getDefaultModuleroute,
  getSystemSettings,
  getUserSettings,
  intializeModuleFunctions,
  PageLayout,
  Help,
} from "@brightinsight/bi-web-dms-modules";
import { Patients } from "./modules/patients";
import { Teams } from "./modules/team-list";
import { TeamsManagement } from "./modules/team-management";
import { RegisterPageProperties } from "./modules/register";
 import { PatientManagement } from "./modules/patient-management";
 import { PatientDetails as PatientDetail } from "./modules/patient-detail";

const exportsObject = {
  GenericHeader,
  NavigationBarWrapper,
  Profile,
  LoginExpireModal,
  Login,
  RegisterPage,
  ResetPassword,
  ResetPasswordPage,
  userPreference,
  getApplicationFeatures,
  featureList,
  getAppContextRoute,
  getDefaultModuleroute,
  getSystemSettings,
  getUserSettings,
  intializeModuleFunctions,
  Patients,
  Teams,
  TeamsManagement,
  PatientManagement,
  PageLayout,
  Onboarding,
  Help,
  RegisterPageProperties,
  PatientDetail,
};

import React from "react";
import { createRoot } from "react-dom/client";
import {
  RenderAppWithTheme,
  loadAppTheme,
} from "@brightinsight/bi-web-portal-base";
import { Onboarding } from "./modules/onboarding";

// Get the root element where the app will be rendered
const rootElement = document.getElementById("care-team-portal");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

const renderAppWithTheme = (theme: object) => {
  root.render(<RenderAppWithTheme {...theme} />);
};

const initializeAppTheme = async () => {
  const theme: any = await loadAppTheme(exportsObject);
  renderAppWithTheme(theme);
};

initializeAppTheme();
